import { useEffect, useState } from 'react';
import { AuthProvider } from './contexts/JWTAuthContext';
import { GlobalStoreProvider } from './contexts/GlobalStoreContext';
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-loading-skeleton/dist/skeleton.css'
import './scss/main.scss';

import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { getSocket, SocketConnect, SocketDisconnect } from './socket';
import { useAuth } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import RenderRoutes from './routes';
import { claimGuestTrial, getAnonToken } from './utils/anonymousSession';


const App = () => {
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { getToken, isSignedIn } = useAuth();

  useEffect(() => {
    let cancelled = false;
    // Provider, not a one-shot token: each reconnect attempt fetches a fresh one, so a blip
    // after the ~60s TTL can still reconnect. It also handles a missing token, so no gate.
    // A guest trial is claimed before the socket switches to the Clerk token.
    const connect = async () => {
      if (isSignedIn && getAnonToken()) {
        await claimGuestTrial();
        if (cancelled) return;
      }
      if (isSignedIn) {
        SocketConnect(() => getToken({ template: "TLK" }));
        return;
      }
      if (getAnonToken()) {
        SocketConnect(() => Promise.resolve(getAnonToken()));
      }
    };

    connect();

    // Reconnect when tab becomes active
    const onVisible = () => {
      if (document.visibilityState === "visible" && getSocket() === null) {
        connect();
      }
    };

    document.addEventListener("visibilitychange", onVisible);

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisible);
      SocketDisconnect();
    };
  }, [isSignedIn, getToken]);

  const checkNetworkStatus = () => {
    const onlineStatus = navigator.onLine;
    setIsOnline(onlineStatus);
    if (!onlineStatus) {
      navigate('/no-network');
    }
  };

  useEffect(() => {
    checkNetworkStatus();
    const intervalId = setInterval(checkNetworkStatus, 6000);
    return () => clearInterval(intervalId);
  }, [navigate]);

  return (
    <Provider store={store}>
      <AuthProvider>
        <GlobalStoreProvider>
          <Toaster
            position="bottom-center"
            reverseOrder={false}
            toastOptions={{
              // Define default options
              className: 'hot-toast-opening-class',
              duration: 3000,
              // style: {
              //   background: '#363636',
              //   color: '#fff',
              // },
              // Default options for specific types
              success: {
                duration: 3000,
                // theme: {
                //   primary: 'green',
                //   secondary: 'black',
                // },
              },
            }}
          />
            {/* {renderRoutes(routes)} */}
            <RenderRoutes />
        </GlobalStoreProvider>
      </AuthProvider>
    </Provider>
  );
};

export default App;
